import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { Form, Spinner } from 'react-bootstrap'
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap'
import { message } from 'antd'

import ReviewResultForm from './ReviewResultForm'

import { updateReviewResult } from '../services'
import { handleError } from '../../../helpers'

export default function EditReviewResultModal({ visible, onClose, reviewResult, reload }) {
	const { handleSubmit, register, formState: { errors }, watch } = useForm({ 
		defaultValues: { 
			group: reviewResult.group,
			area: reviewResult.area,
			condition_desc: reviewResult.condition_desc,
			activity: reviewResult.activity,
			description: reviewResult.description,
			responsable: reviewResult.responsable,
			elements: reviewResult.elements,
		}
	})
	const [loading, setLoading] = useState(false)

	const onSubmit = values => {
		setLoading(true)
		updateReviewResult(reviewResult.id, values)
			.then(res => {
				message.success(res.data.message)
				reload()
				onClose()
			})
			.catch(error => handleError(error, setLoading))
	}

	return (
		<Modal isOpen={visible} toggle={onClose}>
			<ModalHeader toggle={onClose}>Actualizar Registro</ModalHeader>
			<ModalBody>
				<Form onSubmit={handleSubmit(onSubmit)}>
					<ReviewResultForm 
						register={register}
						errors={errors}
						watch={watch}
						editable
					/>
					<Button color='primary' type="submit" disabled={loading}>
						{ loading && <Spinner animation="border" size="sm" className='mr-1' /> }
						Actualizar Registro
					</Button>
				</Form>
			</ModalBody>
		</Modal>
	)
}